import {SALO_STRING_MAP} from '../constants';
import type {SearchCriteria, SmallSALO} from '../types';

/**
 * Helper for converting search criteria to a condensed object
 * @param criteria
 * @returns SmallSALO
 */
export const searchCriteriaToSmallSALO = (criteria: SearchCriteria) => {
	return Object.entries(SALO_STRING_MAP).reduce<SmallSALO>(
		(accum, [small, key]) => {
			return {
				...accum,
				[small]: criteria[key],
			};
		},
		{
			a: 'file',
			b: 0,
			c: 0,
			d: [],
			e: [],
			f: [],
			g: [],
			h: [],
			i: [],
		},
	);
};

export default searchCriteriaToSmallSALO;
